import type { Theme, SxProps } from '@mui/material/styles';

import { Link } from 'react-router';
import React, { useState } from 'react';

import { Stack, Typography, Button, Dialog, DialogTitle, DialogContent, Box } from '@mui/material';

import { fDate, fIsSame } from 'src/utils/format-time';

import { getTime } from 'src/utils';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  sx?: SxProps<Theme>;
  product: any;
  entityType: string;
};

export function ProductDetailsDescription({ product, entityType }: Props) {
  const [openAllDates, setOpenAllDates] = useState(false);
  const [selectedDates, setSelectedDates] = useState([] as any);

  return (
    <Stack sx={{ py: 3, px: 5 }}>
      <Typography
        variant="h6"
        fontFamily="Rubik"
        fontWeight={500}
        sx={{ color: 'text.secondary', textDecoration: 'underline', mb: 4 }}
      >
        Tanıtım
      </Typography>

      <Typography
        variant="body1"
        fontFamily="Rubik"
        fontWeight={400}
        sx={{ color: 'text.secondary', mb: 3 }}
      >
        {product?.listing?.description}
      </Typography>
      <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
        <Typography
          variant="body1"
          fontFamily="Rubik"
          fontWeight={500}
          sx={{ color: 'primary.main' }}
        >
          {product?.organizer?.name}
        </Typography>
      </Stack>
      {/* <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
        <Typography
          variant="body1"
          fontFamily="Rubik"
          fontWeight={400}
          sx={{ color: 'text.secondary' }}
        >
          Kategori:
        </Typography>
        <Typography
          variant="body1"
          fontFamily="Rubik"
          fontWeight={500}
          sx={{ color: 'text.secondary' }}
        >
          {product.listing?.category}
        </Typography>
      </Stack> */}

      {product?.schedule?.days && product.schedule.days.length > 0 && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
          <Iconify icon="mdi:calendar-outline" width={24} sx={{ color: 'primary.main' }} />
          {product?.schedule?.days && product.schedule.days.length > 1 ? (
            <Button
              variant="text"
              sx={{ p: 0 }}
              onClick={() => {
                setSelectedDates(product.schedule.days);
                setOpenAllDates(true);
              }}
            >
              <Typography variant="body1">Tarihleri Gör</Typography>
            </Button>
          ) : product?.schedule?.days && product.schedule.days.length === 1 ? (
            <Typography
              variant="body1"
              fontFamily="Rubik"
              fontWeight={400}
              sx={{ color: 'text.secondary' }}
            >
              {fDate(product.schedule.days[0].date)}
            </Typography>
          ) : (
            <Typography
              variant="body1"
              fontFamily="Rubik"
              fontWeight={400}
              sx={{ color: 'text.secondary' }}
            >
              {fIsSame(product?.schedule?.startDate, product?.schedule?.endDate)
                ? `${fDate(product?.schedule?.startDate)}`
                : `${fDate(product?.schedule?.startDate)}-${fDate(product?.schedule?.endDate)}`}
            </Typography>
          )}
        </Stack>
      )}

      {product?.schedule?.days &&
        product.schedule.days.length > 0 &&
        product.schedule.days?.[0]?.startTime && (
          <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
            <Iconify icon="tabler:clock" width={24} sx={{ color: 'warning.main' }} />
            <Typography
              variant="body1"
              fontFamily="Rubik"
              fontWeight={400}
              sx={{ color: 'text.secondary' }}
            >
              {product?.schedule?.days && product.schedule.days.length > 0
                ? product.schedule.days[0].startTime === 100
                  ? getTime(product.schedule.days[0].startTime)
                  : `${getTime(product.schedule.days[0].startTime)} - ${getTime(product.schedule.days[0].endTime)}`
                : 'Saat bilgisi yok'}
            </Typography>
          </Stack>
        )}

      <Stack direction="row" alignItems="flex-start" gap={1} sx={{ mb: 0.5 }}>
        <Iconify
          icon="proicons:location"
          width={24}
          sx={{
            color: 'error.main',
            visibility: product?.listing?.format === 'online' ? 'hidden' : 'visible',
          }}
        />
        {product?.listing?.format === 'online' ? (
          <Box
            sx={{
              backgroundColor: 'success.main',
              py: 0.5,
              px: 1.5,
              borderRadius: 1,
              fontWeight: 'bold',
              color: 'white',
            }}
          >
            Online
          </Box>
        ) : (
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: 'text.secondary' }}
          >
            <Box>
              <Box component="span" display="block">
                {product?.location?.district === product?.location?.city
                  ? product?.location?.city
                  : `${product?.location?.district}/${product?.location?.city}`}
              </Box>
              {product?.location?.address?.description && (
                <Box component="span" display="block">
                  {product?.location?.address?.description}
                </Box>
              )}
            </Box>
          </Typography>
        )}
      </Stack>

      {product?.duration && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: '#CEC3BE' }}
          >
            Süre:
          </Typography>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: 'text.secondary' }}
          >
            {product?.duration} dk
          </Typography>
        </Stack>
      )}

      {product?.listing?.category && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: '#CEC3BE' }}
          >
            Kategori:
          </Typography>
          {Array.isArray(product?.listing?.category) 
            ? product?.listing?.category.map((category: string, index: number) => (
                <React.Fragment key={index}>
                  <Link
                    to={`/aktivite?kategori=${category}`}
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography
                      variant="body1"
                      fontFamily="Rubik"
                      fontWeight={400}
                      sx={{
                        color: 'text.secondary',
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' },
                      }}
                    >
                      {category}
                    </Typography>
                  </Link>
                  {index < product.listing.category.length - 1 && (
                    <Typography
                      variant="body1"
                      fontFamily="Rubik"
                      fontWeight={400}
                      sx={{ color: 'text.secondary' }}
                    >
                    {" "}
                    </Typography>
                  )}
                </React.Fragment>
              ))
            : (
              <Link
                to={`/aktivite?kategori=${product?.listing?.category}`}
                style={{ textDecoration: 'none' }}
              >
                <Typography
                  variant="body1"
                  fontFamily="Rubik"
                  fontWeight={400}
                  sx={{
                    color: 'text.secondary',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                  }}
                >
                  {product?.listing?.category}
                </Typography>
              </Link>
            )
          }
        </Stack>
      )}

      {product?.quota && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: '#CEC3BE' }}
          >
            Kontenjan:
          </Typography>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: 'text.secondary' }}
          >
            {product?.quota === 100000 ? 'Sınırsız' : product?.quota + ' kişi'}
          </Typography>
        </Stack>
      )}
      {product?.listing?.companionship && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: '#CEC3BE' }}
          >
            Veli Katılımı:
          </Typography>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: 'text.secondary' }}
          >
            {product?.listing?.companionship === 'required'
              ? 'Zorunlu'
              : product?.listing?.companionship === 'maybe'
                ? 'Zorunlu Değil'
                : 'Katılamaz'}
          </Typography>
        </Stack>
      )}
      {product?.location?.parking && product?.listing?.format !== 'online' && (
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.5 }}>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: '#CEC3BE' }}
          >
            Park Yeri:
          </Typography>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: 'text.secondary' }}
          >
            {product?.location?.parking === 'exists'
              ? 'Var'
              : product?.location?.parking === 'limited'
                ? 'Kısıtlı'
                : 'Yok'}
          </Typography>
        </Stack>
      )}
      {product?.hoursBeforeReservationExpires ? (
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 3.5 }}>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: '#CEC3BE' }}
          >
            Rezervasyonun Yapılabileceği Son Saat:
          </Typography>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: 'text.secondary' }}
          >
            {product?.hoursBeforeReservationExpires} saat önce
          </Typography>
        </Stack>
      ) : null}

      {product?.additionalDetails && (
        <Stack direction="column" gap={1} sx={{ mb: 0.5 }}>
          <Typography
            variant="body1"
            fontFamily="Rubik"
            fontWeight={600}
            sx={{ color: 'text.secondary' }}
          >
            Ek Bilgiler:
          </Typography>
          <Typography
            variant="caption"
            fontFamily="Rubik"
            fontWeight={400}
            sx={{ color: 'text.secondary', whiteSpace: 'pre-line' }}
          >
            {product?.additionalDetails}
          </Typography>
        </Stack>
      )}

      <Dialog fullWidth maxWidth="xs" open={openAllDates} onClose={() => setOpenAllDates(false)}>
        <DialogTitle id="alert-dialog-title">Tarihleri Gör</DialogTitle>

        <DialogContent sx={{ pb: 3 }}>
          {selectedDates && selectedDates.length > 0 ? (
            <Box>
              {selectedDates.map((date: any) => (
                <Box
                  key={date.id}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 1,
                  }}
                >
                  <Typography variant="body2">{fDate(date.date)}</Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Typography variant="body2">Tarih seçilmemiş</Typography>
          )}
        </DialogContent>
      </Dialog>
    </Stack>
  );
}
